import React, { useContext } from "react";
import Label from "~/componentes/CustomForm/Label";
import { Input } from "~/componentes/CustomForm";
import sistemaListStore from "../../../../../../componentes/SistemaList/ThisMainComponent/thisStore";
import { useState } from "react";
import { useEffect } from "react";
import api from "~/services/api";

import { Container, ItemColor, ModalColor, SelectColor } from "./styles";

function PrioridadeListColor({ defaultData, setter }) {
  const [prioridades, setPrioridades] = useState([]);
  const [prioridade, setPrioridade] = useState(defaultData ? defaultData : { cor: undefined, id: 0, titulo: "" });
  const [showModal, setShowModal] = useState(false);

  const { state } = useContext(sistemaListStore);
  const { edit, editShow } = state?.modal || {};
  const cores = [
    "C97BDC", "ED6B63", "FFA8B8", "FFC8C3", "F7D8C3",
    "82A5ED", "B5DCF9", "A9E5E3", "A2EDCE", "A0D995",
    "C5D084", "D2C897", "FAE187", "E8BA86", "D3BEAD"
  ];

  useEffect(() => {
    api.get("/signed/empresa/gestorprojeto/gerencia/prioridades", { params: { ativo: 1 } }).then((r) => setPrioridades(r?.data));
  }, []);

  useEffect(() => {
    setter(prioridade);
  }, [prioridade, setter]);

  return (
    <Container>
      <Label title="Prioridade *" className="no-margin" row={true} />
      <div className="Etapa_div_addPrioridades">
        <SelectColor color={prioridade?.cor} onClick={() => setShowModal(!showModal)}>
          <div className="color"></div>
          <div className="button"></div>
        </SelectColor>

        <Input
          name="text-prioridade"
          required={true}
          defaultValue={prioridade?.titulo}
          disabled={prioridade?.id === 0 ? false : true}
          onKeyPress={(event) => {
            const v = event.target.value || "true";
            setPrioridade({ cor: prioridade?.cor, id: prioridade?.id, titulo: v });
          }}
        />
      </div>
      {showModal && (
        <ModalColor>
          {cores.map((item, i) => (
            <ItemColor color={item} onClick={() => {
              const findPrioridade = prioridades?.find((e) => e?.cor === item);
              if (findPrioridade) {
                setPrioridade({ cor: findPrioridade?.cor, id: findPrioridade?.id, titulo: findPrioridade?.titulo });
              } else {
                setPrioridade({ cor: item, id: 0, titulo: "" });
              }
              setShowModal(false);
            }} />
          ))}
        </ModalColor>
      )}
    </Container>
  );
}

export default PrioridadeListColor;
